/*
 *
 * Wallets constants
 *
 */

const BASE_ACTION_CONSTANT = 'app/Wallets';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ADD_MONEY_TO_WALLET = `${BASE_ACTION_CONSTANT}/ADD_MONEY_TO_WALLET`;

export const GET_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/GET_WALLET_STATUS`;

export const UPDATE_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_WALLET_STATUS`;

export const UPDATE_DISPUTE_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_DISPUTE_WALLET_STATUS`;

export const GET_WALLET_BALANCE = `${BASE_ACTION_CONSTANT}/GET_WALLET_BALANCE`;

export const UPDATE_WALLET_BALANCE = `${BASE_ACTION_CONSTANT}/UPDATE_WALLET_BALANCE`;

export const MODIFY_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/MODIFY_WALLET_STATUS`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const CREATE_WALLET = `${BASE_ACTION_CONSTANT}/CREATE_WALELT`;

export const UPDATE_BANK_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_BANK_DETAILS`;

export const UPDATE_FEE_WALLET_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_FEE_WALLET_DETAILS`;

export const UPDATE_DISPUTE_WALLET_BANK_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_DISPUTE_WALLET_BANK_DETAILS`;

export const GET_FEE_WALLET_STATUS_URL = {
  url: '/common/fee-wallets/reference',
  method: 'GET',
};

export const GET_WALLET_BALANCE_URL = {
  url: '/pg/refunds/wallets/balance',
  method: 'GET',
};

export const GET_DISPUTE_WALLET_BALANCE_URL = {
  url: '/pg/disputes/wallets/balance',
  method: 'GET',
};

export const MODIFY_WALLET_STATUS_URL = {
  url: '/pg/refunds/wallets/reference',
  method: 'PATCH',
};

export const CREATE_WALLET_URL = {
  url: '/pg/refunds/wallets',
  method: 'POST',
};

export const ADD_MONEY_TO_FEE_WALLET_URL = {
  url: '/common/fee-wallets/recharge-mode',
  method: 'GET',
};

export const CREATE_DISPUTE_WALLET_URL = {
  url: '/pg/disputes/wallets',
  method: 'POST',
};

export const GET_DISPUTE_WALLET_STATUS_URL = {
  url: '/pg/disputes/wallets/reference',
  method: 'GET',
};

export const UPDATE_DISPUTE_WALLET_URL = {
  url: '/pg/disputes/wallets/reference',
  method: 'PATCH',
};

export const REFUND_WALLET_METADATA = {
  key: 'refundWallet',
  heading: 'Refund Wallet',
  iconName: 'WALLET_REFUND',
};

export const DISPUTE_WALLET = 'disputeWallet';

export const DISPUTE_WALLET_METADATA = {
  key: DISPUTE_WALLET,
  heading: 'Dispute Wallet',
  iconName: 'WALLET_REFUND',
};

export const BANK_DETAILS_META_DATA = [
  {
    key: 'accountNo',
    displayText: 'Account Number',
    fieldValue: 'vba',
  },
  {
    key: 'accountName',
    displayText: 'Account Name',
    fieldValue: 'accountName',
  },
  {
    key: 'ifscCode',
    displayText: 'IFSC Code',
    fieldValue: 'ifsc',
  },
];

export const WALLET_CARDS_META_DETA = [
  {
    key: 'refundWallet',
    heading: 'Refund Wallet',
    iconName: 'WALLET_REFUND',
    infoText: 'Refund',
  },
];

export const ACTIVATE_REFUND_WALLET = 'ACTIVATE_REFUND_WALLET';

export const DEACTIVATE_REFUND_WALLET = 'DEACTIVATE_REFUND_WALLET';

export const ADD_TO_WALLET = 'ADD_TO_WALLET';

export const RECHARGE_IN_PROGRESS = 'RECHARGE_IN_PROGRESS';

export const ACTIVE = 'ACTIVE';

export const HOLD = 'HOLD';

export const BANNER_TEXT = [
  {
    title: 'Effortless Reconciliation',
    description: 'Manage refunds separately for easier reconciliation.',
  },
  {
    title: 'Refunds without Delays',
    description: 'Eliminate hold times for quicker and hassle-free refunds.',
  },
  {
    title: 'Improved Cash Flow',
    description:
      'Get full settlements while refunds are deducted from a separate fund.',
  },
];

export const ACTIVE_FEE_WALLET_INFO =
  'Fee Wallet is activated for you because you are currently on Postpaid Billing. All your monthly invoices will be deducted from this wallet. Please maintain sufficient balance otherwise your settlements may be put on hold.';

export const ON_HOLD_FREE_WALLET_INFO =
  'Your wallet is currently on hold. To re-activate your wallet please reach out to care@cashfree.com';

export const FEE_WALLET = 'feeWallet';

export const REFUND_WALLET = 'refundWallet';

export const MIN_BALANCE_AMOUNT = 5000;

export const IN_ACTIVE = 'IN_ACTIVE';
